import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Global } from "@emotion/react";
import { Root } from "../MUIStyled/Root";
import { Puller } from "../MUIStyled/Puller";
import { StyledBox } from "../MUIStyled/StyledBox";
import { DrawerHeader } from "../MUIStyled/DrawerHeader";
import { Box, Button, useMediaQuery } from "@mui/material";
import Divider from "@mui/material/Divider";
import CssBaseline from "@mui/material/CssBaseline";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import StormScenario from "../StormScenario/StormScenario";
import CheckboxComponent from "../General/CheckboxComponent";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
 comparedStormScenarioConfig,
 stormScenarioConfig,
} from "../../../config/stormScenarioConfig";
import "./Sidebar.css";

/*
collapse
left side
loop through column of options

options props:
number 
a/b
title
options = [[optionName, optionIcon], [optionName1, optionIcon1], [optionName2, optionIcon2]]
*/

function createData(
 number,
 aB,
 title,
 thunk,
 options,
 stateKey,
 switchCase,
 availableKeyName,
 info
) {
 return {
  number,
  aB,
  title,
  thunk,
  options,
  stateKey,
  switchCase,
  availableKeyName,
  info,
 };
}

const SidebarDesktopView = ({
 open,
 setOpen,
 drawerWidth,
 checked,
 setChecked,
 sidebarPullerClassname,
 btnClickOne,
 btnClickTwo,
 reductionStateOne,
 reductionStateTwo,
 withAdaptations,
}) => {
 const dispatch = useDispatch();

 const [stormOptions, setStormOptions] = useState([]);
 const [scenarioContainerClassname, setScenarioContainerClassname] =
  useState("scenario-container");

 const isSmallScreen = useMediaQuery("(max-width: 460px)");
 const isHorizontalScreen = useMediaQuery("(max-height: 560px)");

 const height = window.screen.height;
 const width = window.screen.width;

 const iOS =
  typeof navigator !== "undefined" &&
  /iPad|iPhone|iPod/.test(navigator.userAgent);

 const toggleOpenOrClose = () => {
  if (open === true) {
   setOpen(false);
  } else {
   setOpen(true);
  }
 };

 const toggleDrawer = (isOpen) => (event) => {
  if (
   event &&
   event.type === "keydown" &&
   (event.key === "Tab" || event.key === "Shift")
  ) {
   return;
  }
  setOpen(isOpen);
 };

 //  const toggleiOSDrawer = (newOpen) => () => {
 //   setOpen(newOpen);
 //  };

 //  let updateScenarioButton = document.getElementById("update-scenario-button");
 //  let clickableArea = document.getElementsByClassName("clickable-area");

 useEffect(() => {
  let opts = stormScenarioConfig.map((opt) =>
   createData(
    opt.number,
    opt.aB,
    opt.title,
    opt.thunk,
    opt.options,
    opt.stateKey,
    opt.switchCase,
    opt.availableKeyName,
    opt.info
   )
  );
  setStormOptions(opts);
 }, []);

 useEffect(() => {
  if (!!checked) {
   setScenarioContainerClassname("scenario-container-compare");
  } else {
   setScenarioContainerClassname("scenario-container");
  }
 }, [checked]);

 return (
  <>
   {!!isSmallScreen || !!isHorizontalScreen ? (
    <Box
     // sx={{ cursor: "pointer !important" }}
     // onClick={toggleOpenOrClose}
     className={
      open === true ? "sidebar-puller-open-ios" : "sidebar-puller-closed-ios"
     }
    >
     {/* desktop puller  */}
     <Puller onClick={toggleDrawer(true)} />
    </Box>
   ) : (
    <Box
     sx={{ cursor: "pointer !important" }}
     onClick={toggleOpenOrClose}
     className={
      open === true ? `${sidebarPullerClassname}` : "sidebar-puller-closed"
     }
    >
     {/* <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={toggleOpenOrClose}
            edge="start"
            > */}

     <Box className="collapse-sidebar-button">
      {open === true ? (
       <ChevronLeftIcon fontSize="medium" />
      ) : (
       <ChevronRightIcon fontSize="medium" />
      )}
     </Box>
     {/* </IconButton> */}
    </Box>
   )}

   {!!isSmallScreen || !!isHorizontalScreen ? (
    <div>
     <Root>
      <CssBaseline />
      <Global
       styles={{
        ".MuiDrawer-root > .MuiPaper-root": {
         height: `calc(100% - ${120}px)`,
         overflow: "visible",
        },
       }}
      />

      {open === false ? (
       <Box
        onClick={toggleOpenOrClose}
        sx={{
         textAlign: "center",
         position: "fixed",
         zIndex: "4000",
         bottom: "0px",
         left: "calc(50% - 71px)",
         visibility: "none",
        }}
       >
        <button id="clickable-area" className="clickable-area">
         UPDATE SCENARIO
        </button>
       </Box>
      ) : null}

      <SwipeableDrawer
       anchor="bottom"
       open={open}
       onClose={toggleDrawer(false)}
       onOpen={toggleDrawer(true)}
       swipeAreaWidth={70}
       disableSwipeToOpen={false}
       ModalProps={{
        keepMounted: true,
       }}
      >
       <StyledBox
        sx={{
         backgroundColor: `#0b79bf`,
         position: "absolute",
         top: -46, // 63
         borderTopLeftRadius: 8,
         borderTopRightRadius: 8,
         visibility: "visible",
         right: 0,
         left: 0,
        }}
       >
        <div
         className={
          open === true
           ? "adaptations-buttons-open-ios"
           : "adaptations-buttons-closed-ios"
         }
        >
         {/* show when bottom drawer is open/closed  */}
         {open === true ? (
          <div className="close-ios-drawer">
           <Button
            size="small"
            disabled={false}
            variant="contained"
            className="update-scenario-button"
            id="update-scenario-button"
            onClick={toggleOpenOrClose}
            sx={{
             mt: "6px",
             mb: "6px",
             bgcolor: "var(--broward-blue)",
             color: "white",
             border: "1px solid white",
            }}
           >
            Close
           </Button>
          </div>
         ) : (
          <div className="center-buttons">
           {/* <KeyboardArrowUpIcon className="white-icon" /> */}
          </div>
         )}

         {/* {open === true ? (
                  <div className="adaptations-buttons-ios">
                    <Button
                      className="adaptations-button-ios"
                      variant="contained"
                      size="medium"
                    >
                      No Adaptations
                    </Button>
                    <Button
                      className="adaptations-button-ios"
                      variant="contained"
                      size="medium"
                    >
                      With Adaptations
                    </Button>
                  </div>
                ) : null} */}
        </div>
       </StyledBox>
       <StyledBox
        sx={{
         height: "100%",
         overflowY: "scroll",
        }}
       >
        <Box className="ios-bottom-drawer">
         {/* small screen and mobile options  */}
         <div className="drawer-header-bottom-drawer"></div>
         {!!stormOptions.length && (
          <div className="storm-options-container-ios">
           <div className="option-row-item">
            {stormOptions.map((opt, idx) => (
             <StormScenario
              key={`opt1-${idx}`}
              number={opt.number}
              aB={opt.aB}
              title={opt.title}
              options={opt.options}
              info={opt.info}
              scenarioContainerClassname={"scenario-container-bottom-drawer"}
              thunk={opt.thunk}
              stateKey={opt.stateKey}
              switchCase={opt.switchCase}
              availableKeyName={opt.availableKeyName}
              btnClick={btnClickOne}
              reductionState={reductionStateOne}
             />
            ))}
           </div>
           {/* compare two scenarios  */}
           {!!checked && (
            <div className="option-row-item">
             {!!withAdaptations ? (
              <>
               {/* {comparedStormScenarioConfig.map((opt, idx) => (
                                <StormScenario
                                  key={`opt2-${idx}`}
                                  number={opt.number}
                                  aB={opt.aB}
                                  title={opt.title}
                                  options={opt.options}
                                  info={opt.info}
                                  scenarioContainerClassname={
                                    "scenario-container-compare-mobile"
                                  }
                                  thunk={opt.thunk}
                                  stateKey={opt.stateKey}
                                  switchCase={opt.switchCase}
                                  availableKeyName={opt.availableKeyName}
                                  btnClick={btnClickTwo}
                                  reductionState={reductionStateTwo}
                                />
                              ))} */}
              </>
             ) : (
              <>
               {comparedStormScenarioConfig.map((opt, idx) => (
                <StormScenario
                 key={`opt2-${idx}`}
                 number={opt.number}
                 aB={opt.aB}
                 title={opt.title}
                 options={opt.options}
                 info={opt.info}
                 scenarioContainerClassname={
                  "scenario-container-compare-mobile"
                 }
                 popperContainerClassname={"popper-container-compare"}
                 thunk={opt.thunk}
                 stateKey={opt.stateKey}
                 switchCase={opt.switchCase}
                 availableKeyName={opt.availableKeyName}
                 btnClick={btnClickTwo}
                 reductionState={reductionStateTwo}
                />
               ))}
              </>
             )}
            </div>
           )}
          </div>
         )}
         <div className="checkbox-container">
          <CheckboxComponent checked={checked} setChecked={setChecked} />
         </div>
        </Box>
       </StyledBox>
      </SwipeableDrawer>
     </Root>
    </div>
   ) : (
    <SwipeableDrawer
     className={
      open === true ? "sidebar-content-open" : "sidebar-content-closed"
     }
     open={open}
     anchor="left"
     variant="persistent"
     sx={{
      width: drawerWidth,
      flexShrink: 0,
      "& .MuiDrawer-paper": {
       width: drawerWidth,
       boxSizing: "border-box",
      },
     }}
     disableBackdropTransition={!iOS}
     disableDiscovery={iOS}
     onClose={toggleDrawer(false)}
     onOpen={toggleDrawer(true)}
     swipeAreaWidth={10}
     disableSwipeToOpen={false}
    >
     <Box className="left-drawer" height="100%">
      <DrawerHeader />
      <Divider />
      {/* desktop options  */}
      {!!stormOptions.length && (
       <div className="storm-options-container">
        <div>
         {stormOptions.map((opt, idx) => (
          <StormScenario
           key={`opt1-${idx}`}
           number={opt.number}
           aB={opt.aB}
           title={opt.title}
           options={opt.options}
           info={opt.info}
           scenarioContainerClassname={"scenario-container"}
           thunk={opt.thunk}
           stateKey={opt.stateKey}
           switchCase={opt.switchCase}
           availableKeyName={opt.availableKeyName}
           btnClick={btnClickOne}
           reductionState={reductionStateOne}
          />
         ))}
        </div>
        {/* compare two scenarios  */}
        {!!checked && (
         <div>
          {!!withAdaptations ? (
           <>
            {/* TODO: make a new component for the adaptations. This is a placeholder */}
            {comparedStormScenarioConfig.map((opt, idx) => (
             <StormScenario
              key={`opt2-${idx}`}
              number={opt.number}
              aB={opt.aB}
              title={opt.title}
              options={opt.options}
              info={opt.info}
              scenarioContainerClassname={"scenario-container-compare"}
              thunk={opt.thunk}
              stateKey={opt.stateKey}
              switchCase={opt.switchCase}
              availableKeyName={opt.availableKeyName}
              btnClick={btnClickTwo}
              reductionState={reductionStateTwo}
             />
            ))}
           </>
          ) : (
           <>
            {comparedStormScenarioConfig.map((opt, idx) => (
             <StormScenario
              key={`opt2-${idx}`}
              number={opt.number}
              aB={opt.aB}
              title={opt.title}
              options={opt.options}
              info={opt.info}
              scenarioContainerClassname={"scenario-container-compare"}
              thunk={opt.thunk}
              stateKey={opt.stateKey}
              switchCase={opt.switchCase}
              availableKeyName={opt.availableKeyName}
              btnClick={btnClickTwo}
              reductionState={reductionStateTwo}
             />
            ))}
           </>
          )}
         </div>
        )}
       </div>
      )}
      <div className="checkbox-container">
       <CheckboxComponent checked={checked} setChecked={setChecked} />
      </div>
     </Box>
    </SwipeableDrawer>
   )}
  </>
 );
};
export default SidebarDesktopView;
